import { defineStore } from 'pinia'
import { useCountryStore } from './country'

export const useShipStore = defineStore('bestdealer-ship', () => {
  const country = useCountryStore()

  const _shipping = shallowRef(null)
  const postCode = ref(null)
  const shipCountry = computed(() => _shipping.value ?? country.ipCountry)

  const update = ({ country, postCode: code }) => {
    _shipping.value = country
    postCode.value = code
  }

  return {
    /**
     * 内部状态，暴露出去只是为了插件持久化存储
     */
    _shipping,
    country: shipCountry,
    postCode,
    update
  }
}, {
  persist: true
})
